import { render } from "./NotificationsIcon.vue?vue&type=template&id=65e03b1a&scoped=true"
import script from "./NotificationsIcon.vue?vue&type=script&lang=js"
export * from "./NotificationsIcon.vue?vue&type=script&lang=js"

import "./NotificationsIcon.vue?vue&type=style&index=0&id=65e03b1a&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e03b1a"]])

export default __exports__